import React from 'react'

const InfoMap = props => (
  <svg viewBox="0 0 39 60" {...props}>
    <path
      d="M19.04 26.25c-4.225 0-7.616-3.34-7.616-7.5s3.391-7.5 7.616-7.5c4.224 0 7.615 3.34 7.615 7.5s-3.391 7.5-7.615 7.5m0-26.25C8.51 0 0 8.38 0 18.75S9.52 43.125 19.04 60c9.52-16.875 19.04-30.88 19.04-41.25C38.08 8.38 29.57 0 19.04 0"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
)

export default InfoMap



// WEBPACK FOOTER //
// ./src/components/Icons/InfoMap.js